// src/Utils/authSlice.js  (or src/store/slices/authSlice.js)
import { createSlice } from "@reduxjs/toolkit";
import { STORAGE_KEYS } from "../helpers/Constant";   // ← corrected path

// Use consistent storage keys from helpers
const USER_KEY = STORAGE_KEYS.USER || "jagods_user";
const TOKEN_KEY = STORAGE_KEYS.TOKEN || "jagods_token";

const getInitialState = () => {
  try {
    const user = localStorage.getItem(USER_KEY);
    const token = localStorage.getItem(TOKEN_KEY);
    return {
      user: user ? JSON.parse(user) : null,
      token: token || null,
      isAuthenticated: !!token,
      loading: false,
      error: null,
    };
  } catch (error) {
    console.error("Error loading auth state:", error);
    return {
      user: null,
      token: null,
      isAuthenticated: false,
      loading: false,
      error: null,
    };
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState: getInitialState(),
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      const payload = action.payload;
      state.loading = false;
      state.user = payload.user || payload;
      state.token = payload.token;
      state.isAuthenticated = true;
      state.error = null;
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(state.user));
        localStorage.setItem(TOKEN_KEY, state.token);
      } catch (e) {
        console.error("Error persisting auth data:", e);
      }
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    registerStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    registerSuccess: (state, action) => {
      const payload = action.payload;
      state.loading = false;
      state.user = payload.user || payload;
      state.token = payload.token;
      state.isAuthenticated = true;
      state.error = null;
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(state.user));
        localStorage.setItem(TOKEN_KEY, state.token);
      } catch (e) {
        console.error("Error persisting auth data:", e);
      }
    },
    registerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    },
    logoutUser: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      state.loading = false;
      try {
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(TOKEN_KEY);
      } catch (e) {
        console.error("Error clearing auth data:", e);
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      try {
        localStorage.setItem(USER_KEY, JSON.stringify(state.user));
      } catch (e) {
        console.error("Error updating user data:", e);
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  logoutUser,
  clearError,
  updateUser,
  setLoading,
} = authSlice.actions;

export default authSlice.reducer;